"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankPoint = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var RankPoint = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RankPoint, _super);
    function RankPoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分排行榜前十名';
        _this.code = '101097';
        _this.desc = '积分排行榜前十名';
        _this.requestParams = new point_1.RankPointRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RankPoint;
}(service_1.BaseService));
exports.RankPoint = RankPoint;
//# sourceMappingURL=rankPoint.js.map